'use strict';
const angular = require('angular');

export class PropertyLookupComponent {
  /*@ngInject*/
  constructor(PropertyService, $scope) {
    this.PropertyService = PropertyService;
    this.$scope = $scope;

    this.dtInstance = {};

    this.data = [];

    this.selected = {};
  }

  $onInit() {
    this.config = this.resolve.config;

    this.PropertyService.query((data) => {
      if (this.config && this.config.exclude) {
        let excludeList = Array.isArray(this.config.exclude) ? this.config.exclude : [this.config.exclude];
        this.data = data.filter(contact => !excludeList.includes(String(contact._id)));
      }  else {
        this.data = data;
      }

      if (this.config.multiple && this.config.checkAll)
        this.checkAll();

      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve properties.")
    });

  }

  checkAll() {

    var that = this;

    var api = this.dtInstance.DataTable;
    api.rows({ search:'applied' }).every(function() {

       let _id = api.cell({ row:this.index(), column:0 })
        .nodes()
        .to$()
        .find('span')[0]
         .getAttribute('x-filter-id');

      that.selected[_id] = true;
    });
    this.dtInstance.DataTable.draw();
  }

  uncheckAll() {
    var that = this;
    
    var api = this.dtInstance.DataTable;
    api.rows({ search:'applied' }).every(function() {

      let _id = api.cell({ row:this.index(), column:0 })
        .nodes()
        .to$()
        .find('span')[0]
        .getAttribute('x-filter-id');

      that.selected[_id] = false;
    });
    this.dtInstance.DataTable.draw();
  }
  
  getSelectedCount() {
    return this.data.filter(wa => this.selected[wa._id]).map(wa => wa._id).length;
  }

  okMultiple() {
    let selectedData = this.data.filter(ppty => this.selected[ppty._id]).map(ppty => ppty._id);
    this.close({$value: selectedData});
  }

  ok(property) {
    this.close({$value: property});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryOwner(property) {
    let primary = property.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary || !primary.contact)
      return "-";

    /*
    let name = primary.contact.firstName;
    if (primary.contact.middleName)
      name += " " + primary.contact.middleName;
    name += " " + primary.contact.lastName;*/

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(property) {
    let other = property.contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    /*
    let name = other.contact.firstName;
    if (other.contact.middleName)
      name += " " + other.contact.middleName;
    name += " " + other.contact.lastName;*/

    return this.getComposedName(other.contact);
  }
}

export default angular.module('conduu.propertyLookup', [])
  .component('propertyLookup', {
    template: require('./property-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: PropertyLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/property-lookup/property-lookup.component.js